// extracted by mini-css-extract-plugin
export default {"container":"ShopSection_container__H4gU3","title":"ShopSection_title__xF-EE","line":"ShopSection_line__jBMzN"};